/* eslint-disable */
export default {
  en: 'Inglese',
  ja: 'Giapponese',
  fr: 'Francese',
  de: 'Tedesco',
  es: 'Spagnolo',
  it: 'Italiano',
  pt: 'Portoghese',
  zh: 'Cinese',
  nl: 'Olandese',
  ko: 'Coreano',
  fi: 'Finlandese',
} as const;

// @key: @#@"en"@#@ @source: @#@"English"@#@
// @key: @#@"ja"@#@ @source: @#@"Japanese"@#@
// @key: @#@"fr"@#@ @source: @#@"French"@#@
// @key: @#@"de"@#@ @source: @#@"Deutsch"@#@
// @key: @#@"es"@#@ @source: @#@"Spanish"@#@
// @key: @#@"it"@#@ @source: @#@"Italian"@#@
// @key: @#@"pt"@#@ @source: @#@"Portuguese"@#@
// @key: @#@"zh"@#@ @source: @#@"Chinese"@#@
// @key: @#@"nl"@#@ @source: @#@"Dutch"@#@
// @key: @#@"ko"@#@ @source: @#@"Korean"@#@
// @key: @#@"fi"@#@ @source: @#@"Suomi"@#@
